export default __webpack_public_path__ + "static/media/by-nd.b1260888.svg";